module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-556.951491a.woff2";